var klaviyo = klaviyo || [];
window._klaviyoBISConfig = {
  trigger: {
    collection_page_class: 'font-2 link',
    collection_page_text_align: 'center',
    collection_page_width: '180px',
    collection_page_opacity: '1',
    collection_page_text: 'Notify Me When Available',
    replace_anchor: false,
  },
  modal: {
    headline: '{product_name}',
    body_content: 'Register to receive a notification when this item comes back in stock.',
    email_field_label: 'Email',
    button_label: 'Notify me!',
    subscription_success_label: "You're all set! Keep an eye on out for a back-in-stock message.",
    footer_content: '',
    additional_styles: `
      
      @font-face {
          font-family: 'GT Alpina';
          src: url('//dairyboy.com/cdn/shop/t/133/assets/font-GT Alpina-Regular.woff2?v=3258453604883131631758190629') format('woff2'),
              url('//dairyboy.com/cdn/shop/t/133/assets/font-GT Alpina-Regular.woff?v=16388007074208366841758190635') format('woff');
      }
      @font-face {
          font-family: "Sweet Sans Pro";
          src: url("//dairyboy.com/cdn/shop/t/133/assets/font-SweetSansPro-Regular.woff2?v=30720923137177380711758190631") format("woff2"),
              url("//dairyboy.com/cdn/shop/t/133/assets/font-SweetSansPro-Regular.woff?v=98367155518315127751758190630") format("woff");
          font-weight: 400;
          font-style: normal;
          font-display: swap;
      }

      #klaviyo-bis-modal #container {
          background-image: url('//dairyboy.com/cdn/shop/t/133/assets/site-background.jpg?v=19544677274538758691758190635');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          padding: 80px 40px;
          max-width: 100vw;
      }

      #klaviyo-bis-modal .close {
          font-weight: 400 !important;}

      #klaviyo-bis-modal .btn {
          cursor: pointer;
          display: inline-block;
          text-align: center;
          text-decoration: none;
          white-space: nowrap;
          font-size: 14px;
          transition: background-color 125ms ease-in-out;
          line-height: 24px;
          text-transform: uppercase !important;
          letter-spacing: 0.03rem;
          color: #FFFFFF;
          border-color: var(--color-2);
          background-color: var(--color-2);
          border-radius: 0;
      }

      #klaviyo-bis-modal h3 {
          font-family: "Sweet Sans Pro", sans-serif !important;
          text-transform: uppercase !important;
          font-size: 18px !important;
          text-align: center !important;
          font-weight: 700 !important;
      }

      #klaviyo-bis-modal p {
          font-family: "Monument Grotesk", sans-serif !important;
          text-transform: uppercase !important;
          font-size: 10px !important;
          text-align: center !important;
          max-width: 70%;
          margin: 20px auto;
      }

      #klaviyo-bis-modal option, #klaviyo-bis-modal select, #klaviyo-bis-modal input#email {
          font-family: "GT Alpina", sans-serif !important;   
      }

      #klaviyo-bis-modal .completed_message, #klaviyo-bis-modal .alert {
          font-family: "GT Alpina", sans-serif !important;
          font-size: 10px !important;
          text-align: center !important;
      }

      #klaviyo-bis-modal .alert-success {
          background-color: transparent !important;
          border: none !important;
      }
    `,
    drop_background_color: '#000',
    close_button_color: '#000000',
    error_text_color: '#000000',
    success_text_color: '#000000',
  },
};
klaviyo.init({
  account: 'YkWY6h',
  platform: 'shopify',
  collection_urls: ['/collections/'],
});
klaviyo.enable('backinstock', window._klaviyoBISConfig);